export const PosthogSetup = {
  key: process.env.NEXT_PUBLIC_POSTHOG_KEY,
  host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
}

export const isPosthogEnabled =
  process.env.NEXT_PUBLIC_ENABLE_POSTHOG === 'true'
